import React from 'react';

import { Box, BoxProps } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';
import { themeVars } from '@mds/ui';
type CardProps = BoxProps;

const Card = ({ children, className, sx, ...divProps }: CardProps) => {
    return (
        <Box
            {...divProps}
            className={className}
            sx={[
                (theme: Theme) => ({
                    padding: theme.spacing(2),
                    backgroundColor: themeVars(theme).palette.background.paper,
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%',
                    [theme.breakpoints.up('md')]: {
                        padding: theme.spacing(3),
                    },
                }),
                ...(Array.isArray(sx) ? sx : sx ? [sx as SxProps<Theme>] : []),
            ]}
        >
            {children}
        </Box>
    );
};

export default Card;
